"use client";

import Script from "next/script";
import { useEffect } from "react";
import { useLocale } from "next-intl";

const TEXT_MAP: Record<string, string> = {
  ro: "Programare online",
  ru: "Записаться онлайн",
  en: "Book Now!",
};

function applyButtonText(locale: string) {
  const el = document.querySelector<HTMLElement>(".yButtonText");
  if (!el) return false;
  el.textContent = TEXT_MAP[locale] ?? TEXT_MAP.en;
  return true;
}

export function AltegioWidget() {
  const locale = useLocale();

  useEffect(() => {
    if (applyButtonText(locale)) return;

    const observer = new MutationObserver(() => {
      if (applyButtonText(locale)) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [locale]);

  return (
    <Script
      src="https://w540730.alteg.io/widgetJS"
      strategy="afterInteractive"
      onLoad={() => {
        applyButtonText(locale);
      }}
    />
  );
}
